import type { GlobalPrimitiveFieldId, GlobalSingleRelationFieldId } from '#layers/data-model';
import type { FilterSchemaLookup } from './filter-path';
import type {
	FilterSchemaCollection,
	FilterSchemaId,
	FilterSchemaPrimitiveField,
	FilterSchemaRelationField,
} from './filter-schema';
import { createContext } from 'reka-ui';
import { useProjectSchemaStore } from '~/stores/project-schema';

export interface FilterSchemaContext extends FilterSchemaLookup {
	findCollectionById: (id: FilterSchemaId) => FilterSchemaCollection | undefined;
	findPrimitiveFieldById: (id: GlobalPrimitiveFieldId) => FilterSchemaPrimitiveField | undefined;
	findSingleRelationFieldById: (id: GlobalSingleRelationFieldId) => FilterSchemaRelationField | undefined;
}

const [_injectFilterSchemaContext, provideFilterSchemaContext] = createContext<FilterSchemaContext>('FilterSchema');

export { provideFilterSchemaContext };

export function injectFilterSchemaContext(): FilterSchemaContext {
	const injected = _injectFilterSchemaContext(null);
	if (injected) return injected;

	const store = useProjectSchemaStore();

	return {
		findCollectionById: (id) => store.findCollectionById(id as Parameters<typeof store.findCollectionById>[0]),
		findPrimitiveFieldById: store.findPrimitiveFieldById,
		findSingleRelationFieldById: store.findSingleRelationFieldById,
		findFieldById: store.findFieldById,
		findFieldByApiName: (collection, apiName) => {
			const relationField = collection.relationFields?.find((field) => field.apiName === apiName);
			const primitiveField = collection.primitiveFields.find((field) => field.apiName === apiName);
			return relationField ?? primitiveField;
		},
		findOppositeCollectionByRelationFieldId: (id) => store.findSingleRelationFieldById(id)?.oppositeCollection,
	};
}
